import React,{ useState } from "react";

export default function useTableChecked(records, headCells, filterFn) {
  const pages = [5, 10, 25, records.length];
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(pages[0]);
  const [order, setOrder] = useState();
  const [orderBy, setOrderBy] = useState();

  const TblContainer = (props) => (
    <div style={{ maxHeight: 300, overflowY: "auto" }}>
      <table className="table table-striped table-hover table-sm border-table">
        {props.children}
      </table>
    </div>
  );

  const handleRequestSort = (property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  function EnhancedTableHead({ onSelectAllClick, numSelected }) {
    return (
      <thead>
        <tr>
          <th style={{ background: "#055182", color: "white", width: "20px" }}>
            <input
              type="checkbox"
              onChange={onSelectAllClick}
              checked={records.length > 0 && numSelected === records.length}
            />
          </th>
          {headCells.map((headCell) => (
            <th
              key={headCell.id}
              style={{
                background: "#055182",
                color: "#fff",
                width: headCell.width,
                textAlign: headCell.textAlign,
                fontWeight: "bold",
                fontSize: "12px",
              }}
              onClick={() => handleRequestSort(headCell.id)}
            >
              {headCell.label}
            </th>
          ))}
        </tr>
      </thead>
    );
  }

  const handleChangePage = (newPage) => {
    if (newPage >= 0 && newPage < Math.ceil(records.length / rowsPerPage)) {
      setPage(newPage);
    }
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const TblPagination = () => (
    <div style={{ marginTop: "10px" }}>
      <button onClick={() => handleChangePage(page - 1)} disabled={page === 0}>
        Anterior
      </button>
      <span> Página {page + 1} de {Math.ceil(records.length / rowsPerPage)} </span>
      <button
        onClick={() => handleChangePage(page + 1)}
        disabled={(page + 1) * rowsPerPage >= records.length}
      >
        Siguiente
      </button>

      <select value={rowsPerPage} onChange={handleChangeRowsPerPage}>
        {pages.map(size => (
          <option key={size} value={size}>{size} filas por página</option>
        ))}
      </select>
    </div>
  );

  function stableSort(array, comparator) {
    return [...array].sort(comparator);
  }

  function getComparator(order, orderBy) {
    return order === "desc"
      ? (a, b) => descendingComparator(a, b, orderBy)
      : (a, b) => -descendingComparator(a, b, orderBy);
  }

  function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) return -1;
    if (b[orderBy] > a[orderBy]) return 1;
    return 0;
  }

  const recordsAfterPagingAndSorting = () => {
    return stableSort(
      filterFn.fn(records),
      getComparator(order, orderBy)
    ).slice(page * rowsPerPage, (page + 1) * rowsPerPage);
  };

  return {
    TblContainer,
    EnhancedTableHead,
    TblPagination,
    recordsAfterPagingAndSorting,
  };
}
